var Handlebars = require("/root/project/webapp/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "        <span class=\"idea-private\" style=\"margin-right: 8px;\">\n            <i class=\"fa fa-lock\"></i>\n            "
    + container.escapeExpression(__default(require("/root/project/webapp/src/common/ui/template/helper/i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"feedback:idea.public.private",{"name":"i18n","hash":{},"data":data}))
    + "\n        </span>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.lambda, alias3=container.escapeExpression;

  return "<td>\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isPrivate : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "    <a href=\""
    + alias3(alias2((depth0 != null ? depth0.url : depth0), depth0))
    + "\" class=\"push-state\">\n        "
    + alias3(alias2((depth0 != null ? depth0.title : depth0), depth0))
    + "\n    </a>\n</td>\n<td>\n    <span class=\"idea-state\" style=\"background-color: "
    + alias3(alias2((depth0 != null ? depth0.stateColor : depth0), depth0))
    + "\">"
    + alias3(__default(require("/root/project/webapp/src/common/ui/template/helper/i18n.js")).call(alias1,"feedback:idea.state",{"name":"i18n","hash":{"keySuffix":(depth0 != null ? depth0.state : depth0)},"data":data}))
    + "</span>\n</td>\n<td>\n    <img class=\"img-circle icon\" src=\""
    + alias3(__default(require("/root/project/webapp/src/common/ui/template/helper/image.js")).call(alias1,((stack1 = (depth0 != null ? depth0.request_user : depth0)) != null ? stack1.image_url : stack1),"small",{"name":"image","hash":{},"data":data}))
    + "\" alt=\"Icon of "
    + alias3(alias2(((stack1 = (depth0 != null ? depth0.request_user : depth0)) != null ? stack1.name : stack1), depth0))
    + "\">\n    "
    + alias3(alias2(((stack1 = (depth0 != null ? depth0.request_user : depth0)) != null ? stack1.name : stack1), depth0))
    + "\n</td>\n<td style=\"text-align: right;\">\n    "
    + alias3(alias2((depth0 != null ? depth0.commentNum : depth0), depth0))
    + "\n</td>\n<td style=\"text-align: right;\">\n    "
    + alias3(__default(require("/root/project/webapp/src/common/ui/template/helper/time.js")).call(alias1,(depth0 != null ? depth0.updatedAt : depth0),"+09:00",{"name":"time","hash":{},"data":data}))
    + "\n</td>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./feedback/ui/template/idea/item.hbs
// module id = 1087
// module chunks = 0